import { Component, OnInit } from '@angular/core';
import { DashboardEmployeeService } from '../dashboard-employee.service';
import { MatSnackBar } from '@angular/material';
import { MatDialog, MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-request-unlock-dialog',
  templateUrl: './request-unlock-dialog.component.html',
  styleUrls: ['./request-unlock-dialog.component.css']
})
export class RequestUnlockDialogComponent implements OnInit {
  public unlockrequestDescription: string = '';
  public showerror: boolean;
  constructor(
    public dashboardEmployeeService: DashboardEmployeeService,
    public snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<RequestUnlockDialogComponent>,
    public dialog: MatDialog,
  ) { }

  ngOnInit() {
  }

  /**function to submit unlock request*/
  submitUnlockRequest() {
    if (this.unlockrequestDescription == '') {
      this.showerror = true;
    } else {
      this.showerror = false;
      this.dashboardEmployeeService.submitRequestUnlock(this.unlockrequestDescription).subscribe((data) => {
        this.snackBar.open('Request for unlock submitted succcessfully', 'OK', {
          duration: 3000,
        });
        let dialogRef;
        dialogRef = this.dialog.closeAll();
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/employee/dashboard-employee/request-unlock-dialog/request-unlock-dialog.component.ts